<mat-card style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div class="header-color" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: row;" translate>
        Meal Service Balance
      </div>
      <div *ngIf="!isV10" style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center;padding-right: 8px; ">
        <button *ngIf="userType==2 && showPay == true" mat-stroked-button class="mat-card-button" (click)="payClick()">
            <span translate>Pay</span>
        </button>
      </div>
      <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center; padding-right: 5px;flex-grow:unset;">
        <button mat-stroked-button class="mat-card-button" (click)="viewDetailsClick()"><span translate>Go To Meal Service</span></button>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; flex: 1">
      <mat-list style="display: flex;flex-direction: column;flex: 1;" role="list">
        <mat-list-item role="listitem" *ngIf="rolloverBalance > 0">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Rollover Balance</div>
            <div>{{rolloverBalance | number: '1.2'}}</div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Deposits</div>
            <div>{{deposits | number: '1.2'}}</div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1;" translate>Charges</div>
            <div>{{charges | number: '1.2'}}</div>
            <mat-divider></mat-divider>
          </div>
        </mat-list-item>
        <mat-list-item role="listitem">
          <div style="display: flex; flex-direction: row; flex: 1;">
            <div style="display: flex; flex: 1; justify-content: flex-end; padding-right: 10px;font-weight:bold;" translate>Balance</div>
            <div style="display: flex" [ngClass]="checkIfNegative(balance)">
              <div>
                {{absBalance | currency}}
              </div>
              <div style="padding-left: 5px" *ngIf="balance < 0" translate>
                Overdrawn
              </div>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
    <div style="display: flex; flex-direction: row; padding: 5px">
      <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; margin-left: 10px">
        <button mat-stroked-button class="mat-card-close-button" (click)="closeClick()"><span translate>Close</span></button>
      </div>
    </div>
  </div>
</mat-card>
